module.exports = __webpack_public_path__ + "static/media/developers.6ae1c133.jpg";